// extracted by css-extract-rspack-plugin
export default {"chatikDeepLink":"chatik-deep-link--ucd59A04Dts1YayT"};